import React from "react";
import {
  IonPage, IonToolbar, IonButtons, IonButton,
  IonIcon, IonTitle, IonHeader, IonContent,
  IonProgressBar, withIonLifeCycle,
} from "@ionic/react";
import {
  document,
  arrowBack,
  fileTrayStacked, peopleCircleOutline,
} from "ionicons/icons";
import {goBackNG} from "../../lib/utils";
import fb from "../../lib/firebase";
import {NavFooter} from "../../components/NavFooter";
import {AppState} from "../../models/app";
import {AppDispatch, RootState} from "../../global.state";
import {connect} from "react-redux";
import {ProprietarioObject} from "../../models/Proprietario";
import AbaProprietario from "./AbaProprietario";
import AbaFazendas from "./AbaFazendas";
import {debug} from "../../config";

interface Props {
  match: {params: {instanceId: string}};
  history: any;
  app: AppState;
  dispatch: AppDispatch;
}

interface State {
  selectedTab: string;
  instance: ProprietarioObject | undefined;
  loading: boolean;
}

class Proprietario extends React.Component<Props, State> {
  private cancelListener: () => void;

  constructor(props: Props) {
    super(props);

    this.state = {
      selectedTab: "home",
      instance: undefined,
      loading: true,
    };

    this.cancelListener = () => {};
  }

  ionViewWillEnter() {
    // reset state
    const instanceId = this.props.match.params.instanceId;
    const instance = this.state.instance;
    if ( !instance || instance.id !== instanceId) {
      this.setState({instance: undefined, loading: true, selectedTab: "home"});
    }

    this.installListener();
  }
  ionViewDidLeave() {
    this.cancelListener();
  }

  installListener = () => {
    const instanceId = this.props.match.params.instanceId;
    const doc = fb.db.collection('proprietarios').doc(instanceId);
    this.cancelListener = doc.onSnapshot((snap) => {
      const proprietario = fb.doc(snap) as ProprietarioObject;
      debug(`Prorietário ${instanceId}`, proprietario);
      this.setState({
        instance: proprietario,
        loading: false,
      });
    });
  };

  onChangeTab = (selectedTab:string) => {
    this.setState({selectedTab});
  };

  onClickBack = () => {
    goBackNG(this.props.app.jumpHistory, this.props.dispatch, this.props);
  };

  render() {
    const tabs:any[] = [
      {
        tab: "home",
        icon: document,
        label: "Cadastro",
      },
      {
        tab: "fazendas",
        icon: fileTrayStacked,
        label: "Fazendas",
      },
    ];

    return (
      <IonPage>
        <IonHeader>
          <IonToolbar color="primary">
            <IonButtons slot="start">
              <IonButton onClick={this.onClickBack}>
                <IonIcon slot="start" icon={arrowBack}/>
              </IonButton>
            </IonButtons>
            <IonTitle className="font-condensed">
              {this.state.instance && this.state.instance.nome}
            </IonTitle>
            <IonIcon icon={peopleCircleOutline} slot="primary" class="pr-3 text-2xl"/>
          </IonToolbar>
        </IonHeader>

        <IonContent>
          {
            !this.state.instance ? <IonProgressBar type="indeterminate"/> :
              <>
                {
                  this.state.selectedTab === "home" &&
                  <AbaProprietario
                    instance={this.state.instance}
                    goBack={this.onClickBack}
                    loading={this.state.loading}
                  />
                }
                {
                  this.state.selectedTab === "fazendas" &&
                  <AbaFazendas
                    instance={this.state.instance}
                  />
                }
              </>
          }
        </IonContent>

        <NavFooter
          value={this.state.selectedTab}
          onChange={this.onChangeTab}
          tabs={tabs}
        />
      </IonPage>
    );
  }
}

export default connect(({app}: RootState) => ({app}))(withIonLifeCycle(Proprietario));
